import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Box, LinearProgress } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import apiClient from "../api/apiClient";
import { uD } from '../context/DC';

const CheckDebtDetails = () => {  
  const token = localStorage.getItem("token");
  const location = useLocation();
  const navigate = useNavigate();
  const { s, c6 } = location.state || {};
  const { mG } = uD();
  const [pg, sP] = useState(0); 
  const [ld, sL] = useState(true); 
  const [d, sD] = useState([]);

  useEffect(() => {
    if (!s || !c6) {
      navigate("/login");
    }
    fR();
  }, [s, c6, navigate]);

  const fR = async () => {
    sL(true);
    sP(0);
    sD([]); 
    try { 
      if (s.length === 0) {
        await mG({t: "Failed",tc: "#e40000",m: "กรุณาเลือกไฟล์ที่ต้องการแสดงข้อมูล",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
        return;
      } 
      const d = {s: s?.length ? s : null};
      const r = await apiClient.get("/api-data/file-detail", {headers: { Authorization: `Bearer ${token}` },params: d });
      if (r.data.s=='0' && r.data.d.rowCount > 0) {
        sD(r.data.d.rows);
      } else if (r.data.s=='0' && r.data.d.rowCount == 0) {
        await mG({t: "Warning",tc: "#ffa000",m: "ไม่พบข้อมูล กรุณาค้นหาข้อมูลใหม่อีกครั้ง",bt: "OK",btc: "white",bc: "#ffb300",bch: "#ff6f00",}); 
        navigate(-1);
      } else {
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
        navigate(-1);
      }      
    } catch (error) {
      let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      navigate(-1);
    }
    sL(false);
    sP(100);
  };

  const hD = async () => {
    sL(true);
    sP(0);
    try {
      const i = await mG({t: "Delete",tc: "#e40000",m: "คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธไฟล์นี้?",bt: "Cancel",btc: "white",bc: "#66bb49",bch: "#3f762c",cf: true,bcfc: "#ff1616",bcfh: "#d40000",bcft: "Confirm",}); 
      if (i) { 
        const r = await apiClient.post("/api-data/file-reject", [{c2:s}], {
          headers: {'s': '0022',  "Authorization": `Bearer ${token}` ,},});
        if (r.data.s === "0") {
          await mG({t: "Completed",tc: "#519a39",m: r.data.m,bt: "OK",btc: "white",bc: "#66bb49",bch: "#3f762c",});         
          sD((prevFiles) => prevFiles.filter((f) => f.c2 !== s));
          navigate(-1);
        } else {
          await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
          navigate(-1);
        }  
      } 
    } catch (error) {
      let errMsg = "";
        if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
        } else if (error?.message) {errMsg = error.message;}
        await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
        navigate(-1);
    }
    sL(false);
    sP(100);
  };

  const hI = async () => {
    sL(true);
    sP(0);
    try {
      const r = await apiClient.post("/api-data/file-import", [{c2:s}], {
          headers: {'s': '0022',  "Authorization": `Bearer ${token}` ,},});
      if (r.data.s === "0") {
        await mG({t: "Completed",tc: "#519a39",m: r.data.m,bt: "OK",btc: "white",bc: "#66bb49",bch: "#3f762c",});         
        sD((prevFiles) => prevFiles.filter((f) => f.c2 !== s));
        navigate(-1);
      } else {
        await mG({t: "Failed",tc: "#e40000",m: r.data.m+r.data.e,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
        navigate(-1);
      }        
    } catch (error) {
      let errMsg = "";
        if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
        } else if (error?.message) {errMsg = error.message;}
        await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
        navigate(-1);
    }
    sL(false);
    sP(100);
  };

  const hB = async () => {
    navigate(-1);
  };

  return (
    <Container component="main" maxWidth="96%" sx={{marginTop: "40px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>
            {ld ? (
              <Box sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}>
                <LinearProgress variant="determinate" value={pg} sx={{ width: '50%' }} />
              </Box>
      
             ) : ( 


      <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
        backgroundColor: "background.paper",
      }}>
        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:0, boxShadow: "none",marginTop: "0px",
          textAlign: "center",
          verticalAlign: "middle",
          padding:1,
          backgroundColor: "#f5f5f5",
          fontSize: "calc(14px + 0.5vw)",
          fontWeight: "bold",
          color: "#333",
        }}>
          ข้อมูลการรับชำระหนี้หรือจ่ายชำระหนี้
        </Box>

        {d.length <= 0 && (
                <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "0px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
                  borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
                }}>
                      "ไม่สามารถแสดงข้อมูลได้ กรุณาลองใหม่อีกครั้ง"
                </Box>
                )}
        
        {d.length > 0 && (
          <>
          <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "0px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
                  borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
                }}>
                      ชื่อไฟล์ : {c6}
                </Box>
        
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 400,
              overflow: "auto", 
              minWidth: 800,    
            }}
          >
            <Table size="small" aria-label="a dense table" sx={{ borderCollapse: 'collapse' }}>
              <TableHead sx={{ backgroundColor: '#f5f5f5', whiteSpace: "nowrap" }}>
                <TableRow sx={{ height: 40 }}>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 1,
                      border: '1px solid rgba(0, 0, 0, 0.3)'
                    }}
                  >
                    #
                  </TableCell>

                  {d.length > 0 &&
                    Object.keys(d[0]).map((_, colIndex) => (
                      <TableCell
                        key={colIndex}
                        align="center"
                        sx={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#f5f5f5",
                          zIndex: 1,
                          border: '1px solid rgba(0, 0, 0, 0.3)'
                        }}
                      >
                        คอลัมน์ {colIndex + 1}
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {d.map((file, index) => (
                  <TableRow key={index} sx={{ height: 40 }}>
                    {/* ลำดับแถว */}
                    <TableCell
                      align="center"
                      sx={{
                        whiteSpace: "pre-wrap",
                        border: "1px solid rgba(0, 0, 0, 0.3)",
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    {/* แสดงทุกคอลัมน์ */}
                    {Object.entries(file).map(([key, value], i) => (
                      <TableCell
                        key={i}
                        align={typeof value === "number" ? "right" : "left"}
                        sx={{
                          whiteSpace: "pre-wrap",
                          border: "1px solid rgba(0, 0, 0, 0.3)",
                        }}
                      >
                        {
                          // ["createdatt"].some(k => key.toLowerCase().includes(k)) && value
                          //   ? new Date(value).toISOString().split("T")[0] // format วันที่
                          //   : String(value ?? "") // กรณีเป็น null หรือ undefined
                          (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}/.test(value))
                            ? new Date(value).toISOString().split("T")[0] // format วันที่
                            : String(value ?? "") // กรณีเป็น null หรือ undefined
                        }
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>

            </Table>
          </TableContainer>

          </>
        )}
        
        {d.length > 0 && (
          <Box sx={{  marginBottom:0, boxShadow: "none",marginTop: "4px" ,boxSizing: "border-box",
            borderRadius: 0,
            padding: "4px 4px",
            textAlign: "center",
            verticalAlign: "middle",
          }}>

            <button
              onClick={hI}
              style={{
                padding: "8px 15px",
                background: "#0061d4",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
                marginRight: "10px",
              }}
              
            >
              นำเข้าข้อมูล
            </button>

            <button
              onClick={hD}
              style={{
                padding: "8px 15px",
                background: "#e40000",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
                marginRight: "10px",
              }}
            >
              ปฏิเสธไฟล์
            </button>

            <button
              onClick={hB}
              style={{
                padding: "8px 15px",
                background: "#11a819ff",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
              }}
            >
              ย้อนกลับ
            </button>
          </Box>
        )}

      </Box>

      )}


    </Container>
  );
};

export default CheckDebtDetails;